<template>
  <div class="vx-loader">
    <div class="loading-container">
      <div class="loading-logo">
        <img src="../assets/images/logo/logo.png" height="30" alt="Logo">
      </div>
      <div class="loading">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
      </div>
    </div>
  </div>
</template>

<style lang="stylus">
  .loading-container  {
    height: 365px

    .loading {
      margin-top: 5px
      width: 35px
      height: 35px
    }
  }

</style>

<script>
export default{
  name: 'vx-loader'
}
</script>
